import { Box } from '@factorialco/deprecated-design-system'

import { ContentViewProps } from 'modules/trainings/components/content/types'
import { ContentModule } from 'modules/trainings/lib/content/Module'

const ModuleView = ({ contentItem }: ContentViewProps<ContentModule>) => {
  return (
    <Box style={{ maxWidth: '720px', width: '100%', gap: '0.5rem' }}>
      <h2 className="text-3xl font-semibold f1-foreground">{contentItem.title}</h2>
      {contentItem.thumbnail && (
        <img style={{ borderRadius: '1rem' }} src={contentItem.thumbnail.url} />
      )}
      <h2 className="text-base font-normal f1-foreground">{contentItem.description}</h2>
    </Box>
  )
}

export { ModuleView }
